
import React from 'react';
import Layout from '@/components/Layout';
import { useUser } from '@/context/UserContext';
import { FadeIn } from '@/components/Animations';
import { Crown } from 'lucide-react';
import UserRankCard from '@/components/leaderboard/UserRankCard';
import ZoneFilter from '@/components/leaderboard/ZoneFilter';
import LeaderboardTable from '@/components/leaderboard/LeaderboardTable';
import LeaderboardTips from '@/components/leaderboard/LeaderboardTips';
import { useLeaderboardData } from '@/components/leaderboard/useLeaderboardData';
import DashboardTabs from '@/components/dashboard/DashboardTabs';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import { useNavigate } from 'react-router-dom';

const Leaderboard = () => {
  const { user, userProgress, isLoading } = useUser();
  const navigate = useNavigate();
  
  const {
    leaderboardData,
    selectedZone,
    setSelectedZone,
    getSortedData,
    getUserRank
  } = useLeaderboardData(user, userProgress);
  
  const handleTabChange = (tab: string) => {
    if (tab === 'overview') {
      navigate('/integrated-dashboard');
    }
  };
  
  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center animate-pulse">Loading...</div>
        </div>
      </Layout>
    );
  }
  
  if (!user) {
    return (
      <Layout>
        <div className="text-center py-12">
          <h2 className="text-2xl font-semibold mb-4">Please log in to view the leaderboard</h2>
          <p className="text-muted-foreground">You need to be logged in to access this page.</p>
        </div>
      </Layout>
    );
  }
  
  // Find the current user's rank
  const currentUserRank = getUserRank();
  const sortedData = getSortedData();
  
  // Find the user entry in the leaderboard data to access zones
  const userLeaderboardEntry = leaderboardData.find(entry => entry.id === user.id);
  
  return (
    <Layout>
      <div className="container max-w-4xl py-8">
        <FadeIn>
          <DashboardHeader 
            title="Hormony Leaderboard"
            description="Top achievers and community rankings"
          />
          
          <DashboardTabs activeTab="leaderboard" onTabChange={handleTabChange}>
            {/* The children prop is passed here as the content for the active tab */}
            <div className="tab-content">
              {/* This content will be rendered by the TabsContent component */}
            </div>
          </DashboardTabs>
          
          <UserRankCard 
            user={user}
            userProgress={userProgress}
            currentUserRank={currentUserRank}
            selectedZone={selectedZone}
            userLeaderboardEntry={userLeaderboardEntry}
          />
          
          <ZoneFilter 
            selectedZone={selectedZone}
            setSelectedZone={setSelectedZone}
          />
          
          <LeaderboardTable 
            sortedData={sortedData}
            selectedZone={selectedZone}
            currentUser={user}
          />
          
          <LeaderboardTips />
        </FadeIn>
      </div>
    </Layout>
  );
};

export default Leaderboard;
